
import {API_ADMIN_WEAVIATE} from 'consts/api'

export default {
  props: {
    coll_name: {type: String, required: true}
  },
  computed: {
    api_url() {
      return `${API_ADMIN_WEAVIATE}/documents/${this.coll_name}`
    }
  },
  methods: {
    formatFilter(filter) {
      // Ensure the string is wrapped in braces if it's not already.
      if (!(filter.startsWith('{') && filter.endsWith('}'))) {
        filter = `{${filter}}`
      }

      // Find word followed by a colon (unquoted keys) and wrap the key in double quotes.
      // For example: {type: 'news'} becomes {"type": 'news'}
      filter = filter.replace(/([{\s,])([a-zA-Z0-9_$]+)\s*:/g, '$1"$2":')

      // Replace all remaining single quotes with double quotes to handle string values.
      // For example: {"type": 'news'} becomes {"type": "news"}
      // But do not replace single quote in double-quoted strings
      // For exmaple "Update the field 'status' in the record" stays intact
      filter = filter.replace(/".*?"|'/g, (match) => {
        return match === '\'' ? '"' : match
      })

      // Validate json
      const parsed = JSON.parse(filter)
      
      // expand shortcuts
      if (parsed.t) parsed['type'] = parsed.t
      if (parsed.q) parsed['query'] = parsed.q
      if (parsed.p) parsed['properties'] = parsed.p
      if (parsed.props) parsed['properties'] = parsed.props
      if (parsed.o) parsed['operator'] = parsed.op
      if (parsed.op) parsed['operator'] = parsed.op
      if (parsed.c) parsed['certainty'] = parsed.c
      if (parsed.cert) parsed['certainty'] = parsed.cert
      if (parsed.d) parsed['distance'] = parsed.d
      if (parsed.dist) parsed['distance'] = parsed.dist
      if (parsed.m) parsed['model'] = parsed.m
      
      if (['b', 'bm'].includes(parsed.type)) parsed.type = 'bm25'
      if (['v', 'vec', 'nv', 'nvec', 'vector'].includes(parsed.type)) parsed.type = 'near-vector'
      
      if (['s'].includes(parsed.model)) parsed.model = 'small'
      if (['a'].includes(parsed.model)) parsed.model = 'ada'

      // Validate query
      switch(parsed.type) {
        case 'bm25':
          if (!parsed.query) {
            throw Error('query should be a non-empty string')  
          }
          if (parsed.operator && !['or', 'and'].includes(parsed.operator)) {
            throw Error('operator should be in [and, or]')  
          }
          break
        case 'near-vector':
          if (!parsed.query) {
            throw Error('query should be a non-empty string')  
          }
          if (!parsed.model) {
            throw Error('model should be in [ada, small]')  
          }
          if (parsed.certainty !== undefined) {
            if (typeof parsed.certainty !== 'number') {
              throw Error('certainty should be a number')  
            }
            if (parsed.certainty < 0 || parsed.certainty > 1) {
              throw Error('certainty should be in [0..1]')
            }
          }
          if (parsed.distance !== undefined) {
            if (typeof parsed.distance !== 'number') {
              throw Error('distance should be a number')  
            }
            if (parsed.distance < 0 || parsed.distance > 1) {
              throw Error('distance should be in [0..1]')
            }
          }
          if (parsed.distance === undefined && parsed.certainty === undefined) {
            throw Error('distance or cetainty is reuqired')
          }
          break
        default:
          throw Error(`unknown type ${parsed.type}, should be in [bm25, near-vector]`)
      }

      return JSON.stringify(parsed)
    }
  }
}
